/* ===========================================================================
   HEYBABE Atelier — motion core
   Optional. Loaded only when settings.enable_motion is true, and every entry
   point re-checks the runtime flag and the user's motion preference.

   This file never reads cart state and never writes a commerce class. If it
   fails to load, the page is unchanged and complete.
   =========================================================================== */

(function () {
  'use strict';

  var Motion = {
    enabled: !!window.HB_MOTION,
    reduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,

    /* Capability gate. Desktop-first: a heavy sequence is never sent to a
       phone, and the static composition is what that phone gets. */
    isHeavyCapable: function () {
      if (window.matchMedia('(min-width: 992px)').matches !== true) return false;
      if ((navigator.deviceMemory || 4) < 4) return false;
      if ((navigator.hardwareConcurrency || 4) < 4) return false;
      if (navigator.connection && navigator.connection.saveData) return false;
      return true;
    },

    /* Never animate above this: past it the visitor is reading, not watching. */
    onReveal: function (el, cb) {
      if (!Motion.enabled || Motion.reduced) return;
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          cb(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
      io.observe(el);
    }
  };

  window.HBMotion = Motion;

  /* Mark the document only once the feature is genuinely on. The CSS that
     hides unrevealed elements is gated on .hb-motion-ready, so with motion
     off nothing is ever invisible. */
  if (Motion.enabled && !Motion.reduced) {
    document.documentElement.classList.add('hb-motion-ready');
  }
})();
